module.exports = __webpack_public_path__ + "static/media/h5_banner1.4f5480e4.png";